import * as _ from 'lodash';
import { IAttendanceRecord } from '../../../../ng2/shared/typings/interfaces/attendance-record.interface';

export class ImAttendanceRecord {
  constructor() {
    // empty block
  }

  hashAttendanceRecordsBySupportId(attendanceRecords: IAttendanceRecord[]) {
    return _.reduce(
      attendanceRecords,
      function(result, attendanceRecord: IAttendanceRecord) {
        const supportId = attendanceRecord.supportId;
        if (!result[supportId]) result[supportId] = [];
        result[supportId].push(attendanceRecord);
        return result;
      },
      {},
    );
  }
}
